module.exports = __webpack_public_path__ + "media/89.79d3601d.mp3";